// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"40b92595","241":"af00ab35","453":"b03e3c98","478":"8aae9bc7","587":"4f5875fb","607":"1ebb9f30","702":"a5fb7c6b"}[chunkId] + ".chunk.js";
};